<app-header></app-header>
<div style="height: calc(100vh - 8.563rem); overflow: auto" cdkScrollable>
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
